"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Used to reject read if end-of-Stream or end-of-file is reached
 * @type {Error}
 */
exports.endOfFile = "End-Of-File";
